import {GameTypeEnum} from '@colonist/game-base-types'
import {useGameStore} from '../GameStoreContext'

const GAME_TYPES_THAT_DO_NOT_SUPPORT_SHARING = [GameTypeEnum.BeginnerMode, GameTypeEnum.Tutorial, GameTypeEnum.BotGame]

export const useCanShareGameResults = () => {
    const gameType = useGameStore((state) => state.gameSettings.gameType)
    return () => !GAME_TYPES_THAT_DO_NOT_SUPPORT_SHARING.includes(gameType)
}
